// extracted by mini-css-extract-plugin
export default {"space":"Space_space__SWbxF"};